import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");

  // Check if token exists
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children; // Render the protected component
};

export default PrivateRoute;
